import React, { useEffect, useState } from 'react';
import { locales } from '../../translations/locales';
import Loading from '../Loading';
import { _$, _setText } from '../../controllers/dom';
import ButtonReturnMod from './configuration/ButtonReturnMod';

const Shop = (props) => {
    const { data, ModuleRP, locale, theme } = props;

    const [selectedOption, setSelectedOption] = useState('');
    const [bought, setBought] = useState(false);

    const buyOption = (optionId) => {
        ModuleRP.buyOption(optionId, selectedOption);
        setBought(optionId);
    };

    useEffect(() => {
        if (data.type !== 'shop') {
            ModuleRP.socket.emit('SHOP', ModuleRP.gameId);
        }
        if (bought && selectedOption) {
            _$(`btn-buyOption-${bought}`).disabled = false;
            _setText(`btn-buyOption-${bought}`, locales[locale].shop['buySig']);
            setBought(false);
        }
    }, [data]);

    return (
        data.type === 'shop' ? (
            <div className='container'>
                <div className={`text-center ${theme === 'DARK' ? 'bg-dark text-light' : 'bg-light text-dark'} w-25`}>
                    <ButtonReturnMod theme={theme} locale={locale} loadGame={ModuleRP.loadGame} />
                </div>
                <div className='alert alert-warning m-2'>
                    <h5>{locales[locale].shop.alpha}</h5>
                </div>
                <div className='row'>
                    {
                        data.listOptions.map((option, index) => (
                            <div key={index}
                                className={`col-4 m-2 p-1 border border-solid border-${theme === 'DARK' ? 'light' : 'dark'} 
                            ${theme === 'DARK' ? 'bg-dark text-light' : 'bg-light text-dark'}`}>
                                <h2>{locales[locale].shop[option.id]}</h2>
                                <p>{locales[locale].shop[option.description].split('<br />').map((text, index) => (
                                    <React.Fragment key={index}>
                                        {index > 0 && <br />}
                                        {text}
                                    </React.Fragment>
                                ))}</p>
                                {
                                    option.options.length > 0 && (
                                        <select
                                            className='form-control'
                                            id='select-option'
                                            onChange={(e) => setSelectedOption(e.target.value)}
                                        >
                                            <option
                                                value={false}
                                            >
                                                {locales[locale].shop.selectOption}
                                            </option>
                                            {
                                                option.options.map((opt, index) => (
                                                    data.gameOptions[option.id] && !data.gameOptions[option.id].options.includes(opt) ? (
                                                        <option
                                                            key={index}
                                                            value={opt}
                                                        >
                                                            {locales[locale].shop[opt]}
                                                        </option>
                                                    ) : null
                                                ))
                                            }
                                        </select>
                                    )
                                }
                                {
                                    data.gameOptions[option.id].options.length > 0 && (
                                        <div className='alert alert-info'>
                                            {locales[locale].shop.optionActive}
                                            {
                                                data.gameOptions[option.id].options.map((opt, index) => (
                                                    <span key={index} className='badge badge-info ml-1 p-1'>
                                                        {locales[locale].shop[opt]}
                                                    </span>
                                                ))
                                            }
                                        </div>
                                    )
                                }
                                <div className='text-center'>
                                    {
                                        data.gameOptions[option.id] && data.gameOptions[option.id].active && !selectedOption ? (
                                            <div className='alert alert-success'>
                                                {locales[locale].shop.optionActive}
                                            </div>
                                        ) : (
                                            <button
                                                className='btn btn-sm btn-success'
                                                id={`btn-buyOption-${option.id}`}
                                                onClick={() => buyOption(option.id)}
                                            >
                                                {locales[locale].shop[option.buyBtn]}
                                                {Number(option.price) > 0 ? ` (${option.price} Extras)` : ` ${locales[locale].shop.free}`}
                                            </button>
                                        )
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        ) : <Loading theme={theme} />
    );
};

export default Shop;
